import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/depop-packaging-guide';

export default function Example() {
  return (
    <>
      <Head>
        <title>Stay on Top of Orders With the Depop Packaging Guide</title>
        <meta
          name='description'
          content='Keep ahead of your orders and impress your buyers by mastering the art of packaging your items like a PRO with this Depop packaging guide to find out everything you need to know and more!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/depop-packaging-guide' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/depop-packaging-guide' />
        <meta property='og:title' content='Stay on Top of Orders With the Depop Packaging Guide' />
        <meta
          property='og:description'
          content='Keep ahead of your orders and impress your buyers by mastering the art of packaging your items like a PRO with this Depop packaging guide to find out everything you need to know and more!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-08-13T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-08-13T00:00:00-00:00' />
        <meta property='article:tag' content='Depop' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
